<ng-container>
  @if ((rangeFromLargeDesktop$ | async) === true) {
    <now-wbsuche-lib-angebot-termine-slider
      [angebotTemplate]="angebotMitTerminen"
      [selectedAngebot]="(selectedAngebot$ | async)!"
    ></now-wbsuche-lib-angebot-termine-slider>
  }

  <ng-template #angebotMitTerminen let-angebot="angebot">
    @if (angebot) {
      <now-wbsuche-lib-angebot-termine-kachel
        [angebot]="angebot"
        (terminSelected)="terminSelected.emit($event)"
      ></now-wbsuche-lib-angebot-termine-kachel>
    }
  </ng-template>

  <!-- Slidein für mobileview des Angebots mit Terminen -->
  @if ((rangeFromLargeDesktop$ | async) === false) {
    @if (selectedAngebot$ | async; as selectedAngebot) {
      <div
        #slidein
        class="offcanvas offcanvas-end now-slide-in w-100 overflow-visible"
        id="angebot-termine-mobile"
        tabindex="-1"
        aria-label="Angebot mit Terminen"
      >
        <div class="offcanvas-header offcanvas-header-override">
          <button
            id="back-button"
            type="button"
            class="now-btn now-btn-secondary now-btn-icon-only now-icon-arrow-left me-2"
            aria-label="Angebot schließen"
            title="Angebot schließen"
            (click)="slideinCloseClicked()"
          ></button>
          <div class="d-flex flex-column gap-2">
            <h3 class="offcanvas-title h5 text-break" id="angebot_title">
              {{ selectedAngebot?.titel }}
            </h3>
            <div class="d-flex weiterbildungsart-container">
              <span class="sr-only">Weiterbildungsart</span
              ><span aria-hidden="true"><i class="now-icon now-icon-certificate me-2"></i></span
              >{{ weiterbildungsangebot$ | async }}
            </div>
          </div>
        </div>
        <div class="offcanvas-body px-2">
          <ng-container
            *ngTemplateOutlet="angebotMitTerminen; context: { angebot: selectedAngebot }"
          ></ng-container>
        </div>
      </div>
    }
  }
</ng-container>
